import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'components/ui/button'
import { Input } from 'components/ui/input'
import { useAuth } from 'contexts/AuthContext'
import { login as apiLogin } from 'api/auth'

const LoginPage: React.FC = () => {
  const [ecode, setEcode] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const { login } = useAuth()
  
  const onSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault()
    if (!ecode || !password) {
      setError('Please enter employee code and password')
      return
    }
    setLoading(true)
    setError('')
    try {
      const authData = await apiLogin(ecode, password)
      await login(authData)
      navigate('/shipments/in-transit')
    } catch (err: any) {
      setError(err?.message || 'Login failed')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-white">
    {/* Left visual panel with image */}
      <aside className="relative hidden lg:block">
        <div
          className="absolute inset-0 bg-gray-100 bg-center bg-cover"
          style={{ backgroundImage: "url('/images/login-side.png')" }}
        />
        <div className="relative z-10 flex h-full flex-col justify-between p-8 bg-white/30 backdrop-blur-[1px]">
          <div className="flex items-center gap-2">
            <img src="/images/white-logo.png" alt="MRC Logistics Logo" className="h-12 w-auto" />
          </div>
        </div>
      </aside>

    {/* Right auth panel */}
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm border rounded-lg p-6 shadow-sm bg-card">
        <div className="mb-6 text-center">
          <h1 className="text-lg font-semibold">Control Tower Operations</h1>
          <p className="text-sm text-muted-foreground">Sign in with TransIT</p>
        </div>
        {error && (
          <div className="mb-4 text-sm text-red-600">
            {error}
          </div>
        )}
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="ecode" className="text-sm font-medium">Employee Code</label>
            <Input
              id="ecode"
              value={ecode}
              onChange={(e) => setEcode(e.target.value)}
              placeholder="Enter employee code"
              autoComplete="username"
              disabled={loading}
              required
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="password" className="text-sm font-medium">Password</label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              autoComplete="current-password"
              disabled={loading}
              required
            />
          </div>
          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </Button>
        </form>
        </div>
      </div>
    </div>
  )
}

export default LoginPage


